import styled from "@emotion/styled"
import { Link } from "gatsby"

export const H1 = styled.h1`
  font-family: ${props => props.theme.font.main};
  font-size: ${props => props.fSize || "63px"};
  color: ${props => (props.color ? props.color : props.theme.color.text)};
  margin: ${props => props.margin};
  line-height: 66px;
  font-weight: ${props => {
    switch (props.fweight) {
      case "normal":
        return 400
      case "medium":
        return 500
      case "bold":
        return 700
      default:
        return 400
    }
  }};
  text-decoration: ${props => props.tDecoration};
  text-align: ${props => props.tAlign};
  @media ${props => props.theme.breakpoint.tablet} {
    font-size: ${props => props.fSize || "58px"};
  }
  @media ${props => props.theme.breakpoint.mobile} {
    font-size: ${props => props.fSize || "50px"};
  }
`
export const H2 = styled.h2`
  font-family: ${props => props.theme.font.main};
  color: ${props => (props.color ? props.color : props.theme.color.text)};
  font-size: ${props => props.fSize || "45px"};
  color: ${props => (props.color ? props.color : props.theme.color.text)};
  margin: ${props => props.margin};
  line-height: 60px;
  font-weight: ${props => {
    switch (props.fweight) {
      case "normal":
        return 400
      case "medium":
        return 500
      case "bold":
        return 700
      default:
        return 400
    }
  }};
  text-decoration: ${props => props.tDecoration};
  text-align: ${props => props.tAlign};
  @media ${props => props.theme.breakpoint.tablet} {
    font-size: ${props => props.fSize || "40px"};
  }
  @media ${props => props.theme.breakpoint.mobile} {
    font-size: ${props => props.fSize || "35px"};
  }
`
export const H3 = styled.h3`
  font-family: ${props => props.theme.font.main};
  font-size: ${props => props.fSize || "32px"};
  color: ${props => (props.color ? props.color : props.theme.color.text)};
  margin: ${props => props.margin};
  line-height: 48px;
  font-weight: ${props => {
    switch (props.fweight) {
      case "normal":
        return 400
      case "medium":
        return 500
      case "bold":
        return 700
      default:
        return 400
    }
  }};
  text-decoration: ${props => props.tDecoration};
  text-align: ${props => props.tAlign};
  @media ${props => props.theme.breakpoint.tablet} {
    font-size: ${props => props.fSize || "27px"};
  }
  @media ${props => props.theme.breakpoint.mobile} {
    font-size: ${props => props.fSize || "24px"};
  }
`
export const P = styled.p`
  font-family: ${props => props.theme.font.main};
  font-size: ${props => props.fSize || "18px"};
  color: ${props => (props.color ? props.color : props.theme.color.text)};
  margin: ${props => props.margin};
  width: ${props => props.width || "70%"};
  line-height: 24px;
  font-weight: ${props => {
    switch (props.fweight) {
      case "normal":
        return 400
      case "medium":
        return 500
      case "bold":
        return 700
      default:
        return 400
    }
  }};
  text-decoration: ${props => props.tDecoration};
  text-align: ${props => props.tAlign};
  @media ${props => props.theme.breakpoint.tablet} {
    font-size: ${props => props.fSize || "16px"};
  }
  @media ${props => props.theme.breakpoint.mobile} {
    font-size: ${props => props.fSize || "14px"};
  }
`
export const A = styled(Link)`
  color: ${props => props.theme.color.link};
  margin: ${props => (props.m ? props.m : "20px 10px")};
  text-decoration: ${props => props.underline || "none"};
  &:hover {
    color: ${props => props.theme.color.a};
  }
`
export const An = styled.a`
  color: ${props => props.theme.color.a};
  margin: ${props => (props.m ? props.m : "20px 10px")};
  text-decoration: ${props => props.textDeco || "none"};
  transition: 0.2s all ease-out;
  &:hover {
    color: ${props => props.theme.color.link};
  }
`
export const Code = styled.code`
  color: ${props => props.theme.color.pink};
  font-size: ${props => props.fSize || "14px"};
`
export const Hr = styled.hr`
  margin-top: ${props => props.mt || "20px"};
  border: 1px solid #ded6d6;
`
export const Ul = styled.ul`
  color: ${props => props.theme.color.text};
  display: block;
  list-style-type: ${props => props.listStyle || "circle"};
  margin: ${props => (props.m ? props.m : "16px 0")};
  padding-left: 40px;
`
export const Ol = styled.ol`
  color: ${props => props.theme.color.text};
  display: block;
  list-style-type: ${props => props.listStyle || "decimal"};
  margin: ${props => (props.m ? props.m : "16px 0")};
  padding-left: 40px;
`

export const Kbd = styled.kbd`
  font-family: "Noblie", sans-serif;
  font-weight: ${props => props.fWeight || "bold"};
  font-size: ${props => props.fSize || "12px"};
  padding: ${props => props.p || "8px 12px"};
  margin-left: 10px;
  color: #fff;
  background-color: #212529;
  border-radius: 4px;
`
export const Highlight = styled.span`
  font-weight: ${props => props.fweight || "600"};
  color: #794b4b;
  background: #ffe8e8;
  padding: 5px;
`
export const Blockquote = styled.blockquote`
  font-family: ${props => props.theme.font.main};
  font-size: ${props => props.fSize || "18px"};
  width: 80%;
  line-height: 24px;
  margin: 20px 30px;
  padding: 20px 30px;
  color: grey;
  text-align: justify;
  border-top: 1px solid #ded6d6;
  border-left: 1px solid #ded6d6;
`
export const BlockquoteCaption = styled.blockquote`
  font-family: ${props => props.theme.font.main};
  font-weight: bold;
  font-size: ${props => props.fSize || "16px"};
  margin: 10px;
  margin-left: 0;
  padding: 10px;
  color: ${props => props.color || "grey"};
  text-align: justify;
  &:before {
    content: "";
    margin: 6px;
    width: 30px;
    height: 2px;
    background: ${props => props.theme.color.grey};
    display: inline-block;
    margin-left: 0;
  }
`
